import React from 'react';

import { Loader } from '@modules/layout/moleculas';
import { BoxRow } from '@modules/ui/core';

export const SuspenseFallback = () => {
    return (
        <BoxRow height='100%'>
            <Loader initialHeight transparent />
        </BoxRow>
    );
};
